import React, { useEffect, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { stagger, useAnimate } from "framer-motion";
import Image from "next/image";
import auraImage from "../../../../../public/assets/home/cdp-card-aura.png";
import { UseCases } from "./use-cases";

function useAuraAnimation(isActive: boolean) {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const triggerAnimation = async () => {
      await animate(
        isActive
          ? [[".use-case-card", { y: [0, 3, 0] }, { at: "-0.3", delay: stagger(0.1), duration: 0.4 }]]
          : [[".use-case-card", { y: [0] }, { at: "-0.15", duration: 0.05, type: "spring" }]],
      );
    };

    // Do not need `await` because there is no action after the promise
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    triggerAnimation();
  }, [isActive, animate]);

  return scope;
}

export function CdpAnimation({ isCardHovered }: { isCardHovered: boolean }) {
  const [animationActive, setAnimationActive] = useState(false);
  const scope = useAuraAnimation(animationActive);

  useEffect(() => {
    setAnimationActive(isCardHovered);
  }, [isCardHovered]);

  return (
    <Flex ref={scope} className="group" align="center" justify="center" boxSize="100%" pos="relative">
      <Box className="aura-image" boxSize="280px" pos="relative" userSelect="none">
        <Image aria-hidden="true" alt="" width={280} height={280} src={auraImage} style={{ objectFit: "contain" }} />
      </Box>
      <UseCases />
    </Flex>
  );
}
